<ul
  class="{{ class }} rank-list"
  [class.rank-list--horizontal]="orientation === 'horizontal'"
  cdkDropList
  [cdkDropListOrientation]="orientation"
  (cdkDropListDropped)="onDrop($event)"
>
  <li *ngFor="let enumValue of rankedOptions; let i = index" cdkDrag class="enum-option rank-item">
    <span class="rank-number">{{ i + 1 }}.</span>
    <span class="rank-label">{{ enumValue.label }}</span>
    <span class="rank-handle" cdkDragHandle aria-label="Drag to reorder">&#x2630;</span>
  </li>
</ul>
<button
  type="button"
  class="btn mt-2"
  [class.btn-outline-primary]="!isConfirmed"
  [class.btn-success]="isConfirmed"
  [attr.aria-pressed]="isConfirmed"
  (click)="confirmRanking()"
>
  {{ isConfirmed ? "Ranking confirmed" : "Confirm ranking" }}
</button>
